// eslint-disable-next-line import/prefer-default-export
export const LANDLINE_PHONE_NUMBER = "1 970 692 3418"
